import SoomoLogoHorizontal from './SoomoLogoHorizontal';

const SoomoLogo = (props) => <SoomoLogoHorizontal height={34} width={166} />;

export default SoomoLogo;
